import * as _ from "lodash";
import ExternalLogger from "../../logger/ExternalLogger";

var LegacyService = function (
    $rootScope,
    MenuNavigationFactory,
    $window,
    $q,
    $sce,
    $location,
    $http,
    $state
) {
    var service = this;
    var logger = ExternalLogger.getInstance("LegacyService");

    var legacyActiveGroupAccount = {
        individualId: null,
        groupId: null,
        error: null
    };
    var accuCode = null;
    var legacySiteBaseURL = __iframeUrl__;
    var frameSrcUrl = "";
    var frameTitle = "";
    var iframeLoaded = false;
    var keepAliveReady = false;
    var ssoAuthInProgress = false;

    function setLegacySiteBaseUrl() {
        if (__iframeUrl__ === "") {
            legacySiteBaseURL = service.getCurrentDomain();
        }
    }

    service.getCurrentDomain = function () {
        var currentDomain = $location.protocol() + "://" + $location.host();
        if ($window.location.port !== "") {
            currentDomain += ":" + $window.location.port;
        }
        currentDomain += "/";
        return currentDomain;
    };

    //Iframe resizing
    function onReceiveMessage(event) {
        //console.log("message received: origin="+event.origin+" data:",event.data);

        //To reload the next gen parent page from legacy
        if (event.data === "ReloadParentPage") {
            location.reload();
        }

        if (isNaN(event.data)) return; // only accept something which can be parsed as a number

        //console.log("feature loaded");
        iframeLoaded = true;

        var frameId = "legacyFeatureIframe";
        var framePrintLinkId = "legacyFeatureIframePrint";
        var spinnerId = "frame-container-spinner";
        var heightPadding = 145;

        //if the modal frameId exists this is a modal iframe view.
        if (document.getElementById("modal-" + frameId) !== null) {
            frameId = "modal-" + frameId;
            spinnerId = "modal-" + spinnerId;
            heightPadding = 245;
        }

        //if the react-modal frameId exists this is a react modal iframe view.
        if (document.getElementById("react-modal-" + frameId) !== null) {
            frameId = "react-modal-" + frameId;
            spinnerId = "react-modal-" + spinnerId;
            heightPadding = 0;
        }

        var legacyPrintable = ["fund-list-do", "wr-fund-values-do"];

        var iframe = document.getElementById(frameId);
        if (iframe !== null) {
            iframe.style.visibility = "visible";
            var height = parseInt(event.data) + heightPadding; // add some extra height to avoid scrollbar
            iframe.style.height = height + "px";

            var isNgIframe = $location.search().ngIframe !== undefined;
            var parentFrameExists = window.parent != undefined;
            var legacyFeatureIframeExists = document.getElementById("legacyFeatureIframe") !== null;
            var shouldRePost = parentFrameExists && legacyFeatureIframeExists && isNgIframe;
            /*
            console.log('should repost to parent frame?'
                        ,'parentFrameExists=['+parentFrameExists+']'
                        , 'legacyFeatureIframeExists=['+legacyFeatureIframeExists+']'
                        , 'frameId=['+frameId+']'
                        , 'isNgIframe=['+isNgIframe+']'
                        , 'shouldRePost=['+shouldRePost+']'
                        );
            */
            if (shouldRePost) {
                //console.log('Re-Posting page size message to parent frame...', parseInt(event.data));
                window.parent.postMessage(parseInt(event.data), "*");
            }
        }

        var spinner = document.getElementById(spinnerId);
        if (spinner !== null) {
            spinner.style.visibility = "hidden";
            spinner.style.display = "none";

            var framePrintLink = document.getElementById(framePrintLinkId);
            var idx = legacyPrintable.indexOf($state.params.subMenuItem);
            //console.log('checking',$state.params.subMenuItem,idx,framePrintLink);
            if (framePrintLink) {
                if (idx === -1) {
                    framePrintLink.style.visibility = "hidden";
                    framePrintLink.style.display = "none";
                } else {
                    framePrintLink.style.visibility = "visible";
                    framePrintLink.style.display = "block";
                }
            }
        }
    }

    function setAccuCode() {
        if (!accuCode) {
            MenuNavigationFactory.getAccu.query({}, function (code) {
                accuCode = code;
            });
        }
    }

    service.getAccuCode = function () {
        setAccuCode();
        return accuCode;
    };

    //Keep Alive
    service.onKeepAlive = function () {
        var deferred = $q.defer();
        //make legacy no op call if the page is loaded from legacy i-frame.(DEFC-9740)
        if (legacyActiveGroupAccount.groupId || $rootScope.iframe) {
            var legacyKeepAliveUrl =
                legacySiteBaseURL +
                "/servlet/AccountAccess/" +
                service.getAccuCode() +
                "/no_op?param=" +
                _.now();
            //console.log('legacyKeepAliveUrl', legacyKeepAliveUrl);
            $http.get(legacyKeepAliveUrl).then(
                function () {
                    deferred.resolve(true);
                },
                function () {
                    deferred.resolve(false);
                }
            );
        } else {
            deferred.resolve(false);
        }
        return deferred.promise;
    };

    service.getLegacyActiveGroupAccount = function () {
        return legacyActiveGroupAccount;
    };

    /**
     * invoke the legacy site sso "change plans" endpoint.
     */
    function ssoToLegacyChangePlans(accuCode, groupId, individualId) {
        var method = "ssoToLegacyChangePlans()";
        var deferred = $q.defer();
        var ssoToLegacyParams = {
            accu: accuCode,
            individualId: individualId,
            gaId: groupId,
            param: _.now()
        };
        //sso 'set group' to legacy site
        logger.debug("{0} - request data: {1}", [method, JSON.stringify(ssoToLegacyParams)]);
        MenuNavigationFactory.ssoToLegacyChangeGroup.query(
            ssoToLegacyParams,
            function (data) {
                logger.debug("{0} - response: {1}", [method, data ? JSON.stringify(data) : "null"]);
                if (data.status === "success") {
                    ssoAuthInProgress = false;
                    logger.debug("{0} - SUCCESS: {1}", [
                        method,
                        data ? JSON.stringify(data) : "null"
                    ]);

                    legacyActiveGroupAccount.individualId = individualId;
                    legacyActiveGroupAccount.groupId = groupId;
                    legacyActiveGroupAccount.error = null;
                    service.onKeepAlive().then(function (keepAliveReady) {
                        deferred.resolve(keepAliveReady);
                    });
                } else {
                    logger.error("{0} - err: {1}", [method, data ? JSON.stringify(data) : "null"]);
                    ssoAuthInProgress = false;
                    legacyActiveGroupAccount.error = true;
                    deferred.reject();
                }
            },
            function (response) {
                logger.error("{0} - response error: {1}", [
                    method,
                    response ? JSON.stringify(response) : "null"
                ]);
                ssoAuthInProgress = false;
                legacyActiveGroupAccount.error = true;
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    /**
     * invoke the legacy site sso "auth" endpoint.
     */
    function ssoToLegacy(syncToken, accuCode, groupId, individualId) {
        var method = "ssoToLegacy()";
        var deferred = $q.defer();
        var ssoToLegacyParams = {
            synctoken: syncToken,
            accu: accuCode,
            individualId: individualId,
            gaId: groupId,
            param: _.now()
        };
        //sso to legacy site
        logger.debug("{0} - request data: {1}", [method, JSON.stringify(ssoToLegacyParams)]);
        MenuNavigationFactory.ssoToLegacy.query(
            ssoToLegacyParams,
            function (data) {
                logger.debug("{0} - response: {1}", [method, data ? JSON.stringify(data) : "null"]);
                if (data.status === "success") {
                    ssoAuthInProgress = false;
                    logger.debug("{0} - SUCCESS: {1}", [
                        method,
                        data ? JSON.stringify(data) : "null"
                    ]);

                    legacyActiveGroupAccount.individualId = individualId;
                    legacyActiveGroupAccount.groupId = groupId;
                    legacyActiveGroupAccount.error = null;

                    service.onKeepAlive().then(function (keepAliveReady) {
                        deferred.resolve(keepAliveReady);
                    });
                } else {
                    logger.error("{0} - err: {1}", [method, data ? JSON.stringify(data) : "null"]);
                    ssoAuthInProgress = false;
                    legacyActiveGroupAccount.error = true;
                    legacyActiveGroupAccount.groupId = null;

                    deferred.reject();
                }
            },
            function (response) {
                logger.error("{0} - response error: {1}", [
                    method,
                    response ? JSON.stringify(response) : "null"
                ]);
                legacyActiveGroupAccount.error = true;
                ssoAuthInProgress = false;
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    service.performLegacySSO = function (activeGroupAccount) {
        var method = "performLegacySSO()";
        if (ssoAuthInProgress === true) {
            logger.debug("{0} - legacy SSO currently already in progress...", [method]);
            var deferred = $q.defer();
            deferred.resolve();
            return deferred.promise;
        } else {
            logger.debug("{0} - calling doPerformLegacySSO()...", [method]);
            return service.doPerformLegacySSO(activeGroupAccount);
        }
    };

    service.doPerformLegacySSO = function (activeGroupAccount) {
        var method = "doPerformLegacySSO()";
        ssoAuthInProgress = true;

        var deferred = $q.defer();
        logger.debug("{0} - activeGroupAccount={1}, legacyActiveGroupAccount={2}", [
            method,
            activeGroupAccount ? JSON.stringify(activeGroupAccount) : "null",
            legacyActiveGroupAccount ? JSON.stringify(legacyActiveGroupAccount) : "null"
        ]);
        if (activeGroupAccount.groupId !== null && activeGroupAccount.individualId !== null) {
            var ssoAuthNeeded = false;
            var ssoChangePlansNeeded = false;
            if (
                legacyActiveGroupAccount.error ||
                legacyActiveGroupAccount.groupId === null ||
                legacyActiveGroupAccount.individualId === null
            ) {
                ssoAuthNeeded = true;
                /********************************************************** 
            }else if (legacyActiveGroupAccount.individualId && legacyActiveGroupAccount.individualId !== activeGroupAccount.individualId){
                ssoAuthNeeded = true;
            **********************************************************/
            }
            service.onKeepAlive().then(function (keepAliveReady) {
                logger.debug("{0} - onKeepAlive?? keepAliveReady=[{1}]", [
                    method,
                    keepAliveReady ? JSON.stringify(keepAliveReady) : "null"
                ]);
                if (!keepAliveReady) {
                    logger.debug("{0} - keepAlive - false", [method]);
                    ssoAuthNeeded = true;
                    /********************************************************** 
                }else if (legacyActiveGroupAccount.individualId && legacyActiveGroupAccount.individualId !== activeGroupAccount.individualId){
                    ssoAuthNeeded = true;
                **********************************************************/
                } else if (legacyActiveGroupAccount.groupId !== activeGroupAccount.groupId) {
                    logger.debug(
                        "{0} - groupchanged - activeGroupAccount={1}, legacyActiveGroupAccount={2}",
                        [
                            method,
                            activeGroupAccount ? JSON.stringify(activeGroupAccount) : "null",
                            legacyActiveGroupAccount
                                ? JSON.stringify(legacyActiveGroupAccount)
                                : "null"
                        ]
                    );
                    ssoChangePlansNeeded = true;
                }

                logger.debug("{0} - performLegacySSO decisions: auth=[{1}], changeGroup=[{2}]", [
                    method,
                    JSON.stringify(ssoAuthNeeded),
                    JSON.stringify(ssoChangePlansNeeded)
                ]);

                //need to resolve issues with the ChangePlan.do call..for now, always use authenticate
                if (ssoAuthNeeded) {
                    /**********************************************************     
                    var logoutLegacy = __iframeUrl__ + "/logoutNextgen.do";
                    var responsePromise = $http.get(logoutLegacy).success(function(data, status, headers, config){
                    **********************************************************/
                    logger.debug(
                        "{0} - Performing SSO to legacy. activeGroupAccount={1}, legacyActiveGroupAccount={2}",
                        [
                            method,
                            activeGroupAccount ? JSON.stringify(activeGroupAccount) : "null",
                            legacyActiveGroupAccount
                                ? JSON.stringify(legacyActiveGroupAccount)
                                : "null"
                        ]
                    );

                    //retrieve a legacy sso authentication token.
                    var getLegacySSOTokenParams = {
                        individualId: activeGroupAccount.individualId,
                        groupId: activeGroupAccount.groupId,
                        dbName: activeGroupAccount.dbName
                    };

                    logger.debug("{0} - SSO token params:{1}", [
                        method,
                        JSON.stringify(getLegacySSOTokenParams)
                    ]);
                    MenuNavigationFactory.getLegacySSOToken.query(
                        getLegacySSOTokenParams,
                        function (legacySSOToken) {
                            logger.debug(
                                "{0} - legacySSOToken data - invoking legacy sso AUTH:  {1}",
                                [method, legacySSOToken ? JSON.stringify(legacySSOToken) : "null"]
                            );
                            ssoToLegacy(
                                legacySSOToken,
                                service.getAccuCode(),
                                activeGroupAccount.groupId,
                                activeGroupAccount.individualId
                            ).then(deferred.resolve);
                        },
                        function (response) {
                            logger.error("{0} - getLegacySSOToken ERROR: {1}", [
                                method,
                                response ? JSON.stringify(response) : "null"
                            ]);
                            legacyActiveGroupAccount.error = true;
                            ssoAuthInProgress = false;
                            deferred.reject();
                        }
                    );
                    /**********************************************************     
                     }).error(function(data, status, headers, config){
                            //console.log('logOutError',data);
                            legacyActiveGroupAccount.error = true;
                            deferred.reject();
                     });
                    **********************************************************/
                } else if (ssoChangePlansNeeded) {
                    logger.debug(
                        "{0} - Legacy ChangePlan. activeGroupAccount={1}, legacyActiveGroupAccount={2}",
                        [
                            method,
                            activeGroupAccount ? JSON.stringify(activeGroupAccount) : "null",
                            legacyActiveGroupAccount
                                ? JSON.stringify(legacyActiveGroupAccount)
                                : "null"
                        ]
                    );
                    ssoToLegacyChangePlans(
                        service.getAccuCode(),
                        activeGroupAccount.groupId,
                        activeGroupAccount.individualId
                    ).then(deferred.resolve);
                } else {
                    logger.debug(
                        "{0} - ActiveGroupAccount Authorized. activeGroupAccount={1}, legacyActiveGroupAccount={2}",
                        [
                            method,
                            activeGroupAccount ? JSON.stringify(activeGroupAccount) : "null",
                            legacyActiveGroupAccount
                                ? JSON.stringify(legacyActiveGroupAccount)
                                : "null"
                        ]
                    );
                    ssoAuthInProgress = false;
                    deferred.resolve();
                }
            }, deferred.reject);
        } else {
            logger.debug(
                "{0} - Supplied ActiveGroupAccount - missing group. activeGroupAccount={1}, legacyActiveGroupAccount={2}",
                [
                    method,
                    activeGroupAccount ? JSON.stringify(activeGroupAccount) : "null",
                    legacyActiveGroupAccount ? JSON.stringify(legacyActiveGroupAccount) : "null"
                ]
            );
            legacyActiveGroupAccount.error = true;
            ssoAuthInProgress = false;
            deferred.reject();
        }

        return deferred.promise;
    };

    service.setFrameSrcUrl = function (url) {
        frameSrcUrl = url;

        //console.log('iframe loaded', iframeLoaded);
        //console.log('keep alive ready', keepAliveReady);
    };

    service.getFrameSrcUrl = function () {
        return frameSrcUrl;
    };

    service.getLegacySiteBaseUrl = function () {
        return legacySiteBaseURL;
    };

    service.setFrameTitle = function (title) {
        frameTitle = title;
    };

    service.getFrameTitle = function () {
        return frameTitle;
    };

    service.isLegacy = function (menuItem) {
        var rc = !!menuItem && !!menuItem.url && menuItem.url.indexOf("/#/") === -1;
        //console.log('isLegacy',rc, menuItem);
        return rc;
    };

    service.hasError = function () {
        return !!legacyActiveGroupAccount.error;
    };

    service.getIframeLoaded = function () {
        return iframeLoaded; // && keepAliveReady;
    };

    service.initIframeView = function (menuItem, activeGroupAccount, params) {
        var method = "initIframeView";
        iframeLoaded = false;

        var url = __iframeUrl__ + menuItem.url;
        //console.log(method,'initial iframe src url',url);

        if (!!params) {
            for (var key in params) {
                if (params.hasOwnProperty(key) && !!params[key]) {
                    url += "&" + key + "=" + params[key];
                }
            }
        }
        //console.log(method,'final iframe src url',2,url);
        service.setFrameTitle(menuItem.helpText);
        service.setFrameSrcUrl($sce.trustAsResourceUrl(url));
    };

    service.init = function () {
        //console.log("LegacyService initializes..");
        setAccuCode();
        setLegacySiteBaseUrl();
        legacyActiveGroupAccount.individualId = null;
        legacyActiveGroupAccount.groupId = null;

        //MR: Is this the best way to resize the iframe? If so, could we
        //make the event name more descriptive?
        $window.addEventListener("message", onReceiveMessage, false);
    };
};

LegacyService.$inject = [
    "$rootScope",
    "MenuNavigationFactory",
    "$window",
    "$q",
    "$sce",
    "$location",
    "$http",
    "$state"
];

export default LegacyService;
